<template>
  <div>
    <v-tooltip bottom open-delay="700">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          :dark="dark"
          @click="ativarEmbalagemMaster(!embalagemMasterAtivada)"
        >
          <v-icon style="font-size: 20px">mdi-repeat</v-icon>
        </v-btn>
      </template>
      <span>
        Converter para Embalagem {{ !embalagemMasterAtivada ? 'Master' : 'Mínima' }}
      </span>
    </v-tooltip>

    <span class="font-12" :class="{'text-white': dark}">
      Embalagem {{ embalagemMasterAtivada ? 'Master' : 'Mínima' }}
    </span>
  </div>
</template>

<script>
/*
 * ATENÇÃO:
 * a conversao dos produtos do grid da tela de compras
 * esta sendo feita no componente Compra.vue
 */
import { mapGetters } from 'vuex';
import MixinCompra from "../MixinCompra"

export default {
  name: "ConverterEmbalagem",
  mixins: [MixinCompra],
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      embalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster",
      configFornecedor: "fornecedor/getConfig",
      produtosTelaCompra: "tabela_compra/getItems"
    })
  },
  watch: {
    configFornecedor(config) {
      if (localStorage.compras_conversao_embalagem_master_padrao === 'N') {
        this.ativarEmbalagemMaster(config.converter_para_emb_master);
      }
    }
  },
  created() {
    this.ativarEmbalagemMaster(localStorage.compras_conversao_embalagem_master_padrao === 'S' ? true : false);
  },
  destroyed() {
    this.ativarEmbalagemMaster(false);
  },
  methods: {
    ativarEmbalagemMaster(value){
      this.$store.dispatch("EmbalagemTelaDeCompras/setEmbalagemMaster", value);
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped>

</style>
